import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=63854fa5&scoped=true&"
import script from "./WishList.vue?vue&type=script&lang=js&"
export * from "./WishList.vue?vue&type=script&lang=js&"
import style0 from "./WishList.vue?vue&type=style&index=0&id=63854fa5&lang=scss&scoped=true&"
import style1 from "./WishList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63854fa5",
  null
  
)

export default component.exports